import { WorkgroupModalViewComponent } from './workgroup-modal-view.component';
import { NgModule } from '@angular/core';

@NgModule({
    declarations: [
        WorkgroupModalViewComponent
    ],
})
export class WorkgroupModule { }
